<template>
  <div class="home">
    <img
      class="logo-img logo-lg"
      alt="Same crit logo"
      src="../assets/album.jpg"
    />
    <div class="subscribe">
      <div class="subscribe-contain">
        <h2 class="action-label">Listen</h2>
        <a
          target="_blank"
          href="https://www.youtube.com/@SameCritDifferentDay"
          class="subscribe-button youtube-button"
          >Listen on YouTube</a
        >
        <a
          target="_blank"
          href="https://open.spotify.com/show/3sMTVnBHLqAOoM0aC0C0OE"
          class="subscribe-button spotify-button"
          >Listen on Spotify</a
        >
        <a
          target="_blank"
          href="https://podcasts.apple.com/podcast/id1526948092?app=podcast&at=1000lPBj&ls=1&mt=2"
          class="subscribe-button apple-podcasts-button"
          >Listen on Apple Podcasts</a
        >
        <a
          target="_blank"
          href="https://castbox.fm/vic/1526948092"
          class="subscribe-button castbox-button"
          >Listen on Castbox</a
        >
        <a
          target="_blank"
          href="https://overcast.fm/itunes1526948092"
          class="subscribe-button overcast-button"
          >Listen on Overcast</a
        >
        <a
          target="_blank"
          href="https://pca.st/itunes/1526948092"
          class="subscribe-button pocket-casts-button"
          >Listen on Pocket Casts</a
        >
        <a
          target="_blank"
          href="https://podcastaddict.com/podcast/3065013"
          class="subscribe-button podcast-addict-button"
          >Listen on Podcast Addict</a
        >
        <a
          target="_blank"
          href="https://a.co/d/4mbENqP"
          class="subscribe-button amazon-music-button"
          >Listen on Amazon Music</a
        >
        <a
          target="_blank"
          href="https://www.iheart.com/podcast/70911493"
          class="subscribe-button iheartradio-button"
          >Listen on iHeartRadio</a
        >
        <a
          target="_blank"
          href="https://www.spreaker.com/show/4534835/episodes/feed"
          class="subscribe-button rss-feed-button"
          >RSS Feed</a
        >
      </div>
      <div class="subscribe-contain">
        <h2 class="action-label">Connect</h2>
        <a
          target="_blank"
          href="https://discord.gg/nfFsbMzNJD"
          class="site-button discord-button"
          >Join Our Discord</a
        >
        <a
          target="_blank"
          href="https://www.instagram.com/samecritdifferentday/"
          class="site-button instagram-button"
          >Follow Us on Instagram</a
        >
        <a
          target="_blank"
          href="mailto:samecritpodcast@gmail.com"
          class="site-button email-button"
          >Contact Us</a
        >
      </div>
      <div class="subscribe-contain">
        <h2 class="action-label">Shop</h2>
        <a
          target="_blank"
          rel="noopener"
          href="https://same-crit-different-day-shop.fourthwall.com/"
          class="shop-button"
          >Visit the Shop</a
        >
      </div>
    </div>
    <div class="podcast-desc-contain">
      <div class="podcast-description p-font p-size">
        <section>
          <h2 class="h-font">About the Show</h2>
          <p>
            Same Crit Different Day is a
            <a href="https://www.dungeonsanddragons.com/"
              >Dungeons &amp; Dragons</a
            >
            actual-play podcast where a group of longtime friends come together
            to tell an epic fantasy story and inevitably make a complete mess
            of it.
          </p>
        </section>
        <section>
          <h2 class="h-font">The Campaign</h2>
          <p>
            Set in the homebrew world of Vaeloris, our current adventure takes
            us into the frozen wilderness of
            <a href="https://www.dndbeyond.com/sources/dnd/idrotf"
              >Icewind Dale</a
            >
            as we brave
            <a href="https://www.dndbeyond.com/sources/dnd/idrotf"
              >Rime of the Frostmaiden</a
            >
            using the
            <a href="https://www.dungeonsanddragons.com/">5.5E D&amp;D</a>
            rules.
          </p>
        </section>
        <section>
          <h2 class="h-font">Music &amp; Credits</h2>
          <div class="credit-group">
            <h3>Game</h3>
            <div class="credit-items">
              <a href="https://www.dungeonsanddragons.com/"
                >Dungeons &amp; Dragons</a
              >
              <a href="https://beadleandgrimms.com/">Beadle &amp; Grimm's</a>
              <a href="https://krakendice.com/">Kraken Dice</a>
            </div>
          </div>
          <div class="credit-group">
            <h3>Music</h3>
            <div class="credit-items">
              <a href="https://www.monumentstudios.net/">Monument Studios</a>
              <a href="https://creatorchords.com/"
                >Alexander Nakarada at Creator Chords</a
              >
              <a href="https://www.willowispproductions.com/"
                >Will O'Wisp Productions</a
              >
            </div>
          </div>
        </section>
        <section>
          <h2 class="h-font">Join the Table</h2>
          <p>
            We're not professional actors. We're not trying to be perfect.
            We're just a group of people who love D&amp;D, love telling
            stories, and love making each other laugh. So grab your dice, pull
            up a chair, put up your
            <a
              class="easter-egg-link"
              :href="wayneFeetImage"
              target="_blank"
              rel="noopener"
              >feet</a
            >, and join us for the adventure! Same campaign, Same friends, Same
            chaos.
          </p>
          <p>New episodes every Monday.</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import wayneFeetImage from "@/assets/wayne-feet.webp";

export default {
  name: "HomeView",
  data() {
    return {
      wayneFeetImage,
    };
  },
};
</script>
<style lang="scss" scoped>
.action-label {
  margin: 0 0 0.8rem;
  font-family: "Atkinson Hyperlegible", sans-serif;
  color: #eef2f5;
  font-size: 1.35rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.podcast-desc-contain {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: calc(100% - 28px);
  max-width: 900px;
  margin: 0 auto 6rem;
  padding: 1rem 2rem;
  border-radius: 14px;
  background: rgba(23, 27, 34, 0.82);
  text-align: left;

  @media (max-width: 768px) {
    padding: 1rem;
  }
}
.podcast-description section + section {
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(220, 230, 238, 0.2);
}
.podcast-description h2 {
  margin: 0 0 0.5rem;
}
.podcast-description p {
  margin: 0;
  line-height: 1.65;
}
.podcast-description p + p {
  margin-top: 0.75rem;
}
.podcast-description a {
  color: #91b8dd;
  font-family: "Atkinson Hyperlegible", sans-serif;
  font-weight: 700;
}
.podcast-description a:hover,
.podcast-description a:focus-visible {
  color: #c5ddf2;
}
.podcast-description .easter-egg-link,
.podcast-description .easter-egg-link:hover,
.podcast-description .easter-egg-link:focus-visible,
.podcast-description .easter-egg-link:visited {
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  text-decoration: none;
  cursor: text;
}
.credit-group {
  margin-top: 1rem;
}
.credit-items {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
  margin-top: 0.45rem;
  padding-left: 1rem;
  border-left: 2px solid rgba(109, 155, 200, 0.65);
}
.credit-group + .credit-group {
  margin-top: 1.5rem;
}
.credit-group h3 {
  margin: 0;
  color: #eef2f5;
}
.credit-group a {
  font-variant: normal;
  font-weight: 700;
}
.subscribe {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.subscribe-contain {
  width: 100vw;
  @media (min-width: 769px) {
    max-width: 60%;
  }
}
.podcast-description {
  width: 100%;
}
.subscribe-button,
.site-button,
.shop-button {
  display: inline-block;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 0;
  text-indent: -9000px;
}
.subscribe-button,
.site-button {
  margin: 0 5px 5px 0;
  width: 180px;
  height: 60px;
}
.shop-button {
  width: min(450px, calc(100vw - 28px));
  aspect-ratio: 3 / 1;
  background-image: url("../assets/badges/ice-v3/Shop-ice-v2.webp");
}
.apple-podcasts-button {
  background-image: url("../assets/badges/ice-v3/Apple Podcasts-ice-v3.webp");
}
.spotify-button {
  background-image: url("../assets/badges/ice-v3/Spotify-ice-v3.webp");
}
.overcast-button {
  background-image: url("../assets/badges/ice-v3/Overcast-ice-v3.webp");
}
.amazon-music-button {
  background-image: url("../assets/badges/ice-v3/Amazon Music-ice-v3.webp");
}
.castbox-button {
  background-image: url("../assets/badges/ice-v3/Castbox-ice-v3.webp");
}
.podcast-addict-button {
  background-image: url("../assets/badges/ice-v3/Podcast Addict-ice-v3.webp");
}
.pocket-casts-button {
  background-image: url("../assets/badges/ice-v3/Pocket Casts-ice-v3.webp");
}
.iheartradio-button {
  background-image: url("../assets/badges/ice-v3/iHeartRadio-ice-v3.webp");
}
.youtube-button {
  background-image: url("../assets/badges/ice-v3/YouTube-ice-v3.webp");
}
.rss-feed-button {
  background-image: url("../assets/badges/ice-v3/RSS Feed-ice-v3.webp");
}
.discord-button {
  background-image: url("../assets/badges/ice-v3/Discord-ice-v3.webp");
}
.instagram-button {
  background-image: url("../assets/badges/ice-v3/Instagram-ice-v3.webp");
}
.email-button {
  background-image: url("../assets/badges/ice-v3/Email-ice-v3.webp");
}
a {
  text-decoration: none; /* No underline */
  font-variant: small-caps; /* Small caps */
  font-weight: 900;
  color: rgb(82, 169, 255); /* Inherit color from parent */
}
</style>
